export default __webpack_public_path__ + "static/media/duplicate3.699c057f.svg";